// The dismissal guard every confirmation with a write behind it shares — the
// shared `ConfirmDialog`, and the lookup editor's Atlas-native `AlertDialog`,
// which takes this without the rest of the shell. Its own module because a
// component file exporting a plain function loses fast refresh.

/**
 * `onOpenChange`, deaf to dismissal while a write is in flight.
 *
 * Opening is never blocked — only the close paths, which is what Escape, the
 * overlay and the corner X all come through.
 */
export const dismissGuard =
  (onOpenChange: (open: boolean) => void, busy: boolean) => (open: boolean) => {
    if (!open && busy) return;
    onOpenChange(open);
  };
